import PropTypes from 'prop-types';
import React from 'react';

import { patchPermissions } from '../../utils/tab-permissions';
import { PageTemplate } from '../reusable';

import PatchContent from './main';

const Patch2 = (props) => (
  <PageTemplate
    auth={patchPermissions}
    description="Enable and disable product promotions and discount attributes."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href="https://confluence.nike.com/display/RCFITC/RCF+KB+-+Patch+UI+2"
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
        )}
    page={<PatchContent />}
    path={props.location.pathname}
    title="Patch"
  />
    );

    Patch2.propTypes = {
    location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
};

export default Patch2;
